import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

function PaymentService({ open, setOpen }) {
  const termsText = `
แก้ไขเพิ่มเติมเมื่อวันที่ 1 มิถุนายน 2568
ข้อกำหนดและเงื่อนไขการให้บริการเว็บไซต์ https://ebillpay.inet.co.th (ซึ่งต่อไปนี้จะเรียกรวมว่า “เว็บไซต์”) ทำขึ้นระหว่างบริษัท อินเทอร์เน็ต ประเทศไทย จำกัด (มหาชน) (“บริษัท”) ฝ่ายหนึ่งกับผู้ใช้บริการเว็บไซต์ (“ผู้ใช้บริการ”) อีกฝ่ายหนึ่ง เว็บไซต์วางบิลออนไลน์นี้จัดทำขึ้นเพื่อให้ลูกค้าของบริษัท สามารถเข้าดูและชำระค่าบริการต่างๆ ของบริษัทฯ ผ่านระบบออนไลน์ได้อย่างสะดวก รวดเร็ว และปลอดภัย ทั้งนี้ การให้บริการต่าง ๆ ตามเว็บไซต์นี้ อยู่ภายใต้ข้อกำหนดและเงื่อนไขนี้

อย่างไรก็ดี เมื่อผู้ใช้บริการได้ใช้บริการเว็บไซต์นี้ ถือว่าผู้ใช้บริการได้อ่านและเข้าใจข้อกำหนดและเงื่อนไขการให้บริการเว็บไซต์ของบริษัทเป็นอย่างดีแล้ว การใช้บริการถือเป็นการแสดงเจตนาตกลงและยอมรับข้อกำหนดและเงื่อนไขการให้บริการเว็บไซต์ของบริษัททุกประการ

การเข้าเป็นสมาชิกของผู้ใช้บริการ
เพื่อให้ผู้ใช้บริการสามารถใช้บริการเว็บไซต์ของทางบริษัทได้อย่างครบถ้วน ทางบริษัทจะส่งข้อมูลการเข้าสู่ระบบให้กับทางอีเมลล์ของผู้ใช้บริการ บริษัทขอสงวนสิทธิที่จะปฏิเสธการสมัครสมาชิกของผู้ใช้บริการ ในกรณีการยกเลิกการให้บริการถาวร (terminate) บริษัทจะแจ้งเป็นลายลักษณ์อักษร พร้อมระบุเหตุผลประกอบ อาทิ เงื่อนไข ในการให้บริการที่เกี่ยวข้อง ข้อเท็จจริง พฤติการณ์ การแจ้งโดยบุคคลภายนอก หรือระยะเวลา ในการใช้สิทธิโต้แย้งให้ผู้ใช้บริการทราบล่วงหน้าไม่น้อยกว่าสามสิบ (30) วัน ผู้ใช้งานมีหน้าที่เก็บรักษาชื่อผู้ใช้และรหัสผ่านไว้เป็นความลับ และรับผิดชอบต่อการใช้งานทั้งหมดภายใต้บัญชีของตนเอง

อย่างไรก็ตาม ระยะเวลาและการแจ้งเหตุผลดังกล่าว ไม่ใช้บังคับกับกรณี ดังต่อไปนี้
(1) เป็นการปฏิบัติตามกฎหมายหรือคำสั่งตามกฎหมายที่ทำให้ไม่สามารถแจ้งผู้ใช้บริการได้ ภายในระยะเวลาที่กำหนด
(2) เป็นการฝ่าฝืนเงื่อนไขในการให้บริการซ้ำเรื่องเดิมหรือที่เป็นเรื่องร้ายแรง และมีกำหนดไว้ ในเงื่อนไขในการให้บริการอย่างชัดเจนแล้ว

1. การลงทะเบียนและการเข้าสู่ระบบ
1.1 ผู้ใช้งานจะต้องลงทะเบียนหรือได้รับข้อมูลบัญชีผู้ใช้งานจากบริษัท เพื่อเข้าสู่ระบบ
1.2 ผู้ใช้งานมีหน้าที่รักษาข้อมูลบัญชีผู้ใช้งานและรหัสผ่านไว้เป็นความลับ
1.3 INET ขอสงวนสิทธิ์ในการระงับบัญชีหากตรวจพบการใช้งานที่ผิดปกติหรือฝ่าฝืนข้อกำหนด

2. การแสดงผลข้อมูลและการชำระเงิน
2.1 ข้อมูลใบแจ้งหนี้และยอดชำระที่ปรากฏบนเว็บไซต์นี้เป็นข้อมูลที่บริษัทจัดทำขึ้นตามระบบงานบัญชีของบริษัท
2.2 ผู้ใช้งานสามารถเลือกช่องทางการชำระเงินที่ระบุไว้ เช่น การชำระผ่านบัตรเครดิต/เดบิต ระบบ PromptPay การชำระเงินจะถือว่าเสร็จสมบูรณ์เมื่อระบบได้รับการยืนยันจากผู้ให้บริการทางการเงิน

3. การยืนยันการชำระ (Payment Confirmation)
3.1 ระบบจะแจ้ง “สำเร็จ” เมื่อได้รับการยืนยันจากระบบธนาคาร
3.2 กรณีธนาคารติดขัด หรือแจ้งยอดไม่ตรง ระบบยังไม่ถือว่าชำระเสร็จ
3.3 ผู้ใช้งานควรตรวจสอบ “ประวัติรายการ” และกรอกข้อมูลการชำระ (เช่น โบนัสธนาคาร เพื่อนำเข้าโดยอัตโนมัติ)

4. นโยบายใบแจ้งหนี้/ใบเสร็จ
บริษัทฯ ออกใบแจ้งหนี้ เลขประจำตัวผู้เสียภาษี และใบเสร็จให้ตามคำขอตามอีเมลล์ที่ผู้ใช้บริการระบุประสงค์จะรับใบเสร็จรับเงิน/ใบกำกับภาษีสามารถดาวน์โหลดใบแจ้งหนี้และใบเสร็จรับเงิน/ใบกำกับภาษีได้บนเว็บไซต์

5. ความปลอดภัยของข้อมูล
5.1 ใช้มาตรการ SSL/TSL พร้อมมาตรฐาน PCI DSS และ PDPA
5.2 บริษัทฯ ไม่เก็บข้อมูลบัตรเครดิตเต็มรูปแบบ (“full card data”) ฯลฯ

6. การแก้ไขเงื่อนไข
บริษัทขอสงวนสิทธิในการแก้ไข เปลี่ยนแปลง เพิ่มเติม ตัดทอน บรรดาข้อกำหนดและเงื่อนไขการให้บริการใด ๆ ที่กำหนดไว้ในเว็บไซต์นี้ อย่างไรก็ดี บริษัทอาจชี้แจงการแก้ไขเปลี่ยนแปลงดังกล่าวบนหน้าเว็บไซต์ ภายใน 24 ชั่วโมงก่อนจะมีการแก้ไข เปลี่ยนแปลง ผู้ใช้บริการมีหน้าที่ติดตามการแก้ไขเปลี่ยนแปลงต่าง ๆ อยู่เสมอ และหากภายหลังการแก้ไขเปลี่ยนแปลง ผู้ใช้บริการยังคงใช้บริการเว็บไซต์อยู่ ถือว่าผู้ใช้บริการได้อ่านและเข้าใจ จึงได้ยอมรับตามข้อกำหนดและเงื่อนไขการใช้บริการที่ได้มีการเปลี่ยนแปลงนี้ อย่างไม่มีเงื่อนไข ผู้ใช้บริการไม่อาจอ้างเหตุในการไม่ทราบถึงการเปลี่ยนแปลงข้อกำหนดและเงื่อนการใช้บริการมาเป็นเหตุในการฝ่าฝืนข้อกำหนดและเงื่อนไขนี้ได้

7. การจำกัดความรับผิดของบริษัท
บริษัทขอปฏิเสธการรับผิดในความเสียหายที่เกิดขึ้นจากการทุจริต ปลอมแปลงเอกสารและข้อมูล ละเมิดกฎหมาย หรือการกระทำอื่นใดของผู้ใช้บริการทั้งปวง โดยผู้ใช้บริการขอสละสิทธิในการเรียกร้องให้บริษัทรับผิดใด ๆ จากความเสียหายดังกล่าว
บริษัทไม่รับประกันความถูกต้องของข้อมูลใด ๆ ไม่ว่าข้อมูลเหล่านั้นจะเป็นของบริษัทหรือเป็นข้อมูลที่สร้างจากสมาชิก แต่อย่างไรก็ดี กรณีที่บริษัทได้รับแจ้งจากผู้ที่เกี่ยวข้องหรือบุคคลที่สามว่าข้อมูลที่ปรากฎบนเว็บไซต์นั้นอาจก่อให้เกิดความเสียหายกับบุคคลอื่นไม่ว่าโดยตรงหรือโดยอ้อม บริษัทขอสงวนสิทธิที่จะพิจารณาเรื่องดังกล่าวตามสมควรเป็นกรณี ๆ ซึ่งอาจนำไปสู่การระงับการเผยแพร่ข้อมูลดังกล่าวไม่ว่าจะเป็นการชั่วคราวหรือถาวรตามสมควรแก่กรณี ทั้งนี้ สมาชิกผู้สร้างข้อมูลดังกล่าวนั้นยังคงต้องรับผิดชอบในความเสียหายเช่นเดิม
ข้อจำกัดความรับผิดของบริษัทดังกล่าวนี้ ให้รวมไปถึงความผิดพลาดจากการให้บริการ บทความ รับส่งข้อมูล หรือการกระทำการใด ๆ ของบริษัท พันธมิตรทางธุรกิจของบริษัท ผู้ให้บริการร่วมหรือผู้ใช้บริการอินเตอร์เน็ตอื่น ๆ ด้วย

8. การส่งข้อมูลประชาสัมพันธ์
บริษัทอาจส่งไปรษณีย์อิเล็กทรอนิกส์ (E-mail) หรือข้อความอิเล็กทรอนิกส์อื่นใด เกี่ยวกับผลิตภัณฑ์และบริการที่ผู้ใช้บริการอาจสนใจไปยังผู้ใช้บริการเป็นคราว ๆ ไป โดยผู้ใช้บริการตกลงและยินยอมรับไปรษณีย์อิเล็กทรอนิกส์ (E-mail) หรือข้อความอิเล็กทรอนิกส์อื่นใดนี้ อย่างไรก็ตามผู้ใช้บริการอาจใช้สิทธิปฏิเสธการรับไปรษณีย์อิเล็กทรอนิกส์ (E-mail) หรือข้อความอิเล็กทรอนิกส์ทั้งหมดตามช่องทางที่บริษัทได้จัดไว้ให้ ทั้งนี้ หากผู้ใช้บริการปฏิเสธที่จะรับไปรษณีย์อิเล็กทรอนิกส์ (E-mail) หรือข้อความอิเล็กทรอนิกส์ทั้งหมด ถือว่า ผู้ใช้บริการรับทราบว่าผู้ใช้บริการอาจไม่สามารถใช้บริการของบริษัทและบริษัทในเครือได้อย่างครบถ้วน หรือเข้าใช้บริการบางเว็บไซต์ได้อย่างมีประสิทธิภาพ

9. ทรัพย์สินทางปัญญา
9.1 สิทธิในเนื้อหาทั้งหมดที่ปรากฏบนเว็บไซต์ รวมถึงโลโก้ ข้อความ ภาพ และซอฟต์แวร์ เป็นทรัพย์สินของ INET ห้ามผู้ใช้งานทำการคัดลอก ดัดแปลง เผยแพร่ หรือใช้ประโยชน์เชิงพาณิชย์จากเนื้อหาบนเว็บไซต์นี้โดยไม่ได้รับอนุญาตเป็นลายลักษณ์อักษรจาก INET
9.2 สิ่งประดิษฐ์ใหม่ การปรับปรุง และการพัฒนา สิทธิในทรัพย์สินทางปัญญาในงานเป็นสิทธิของ INET และสิทธิในทรัพย์สินทางปัญญาที่เกี่ยวข้องจะต้องเกิดขึ้นโดยอัตโนมัติหรือโอนทันที ที่ได้มีการสร้างงานนั้นขึ้น งานอันมีลิขสิทธิ์ทั้งหมดที่ดำเนินการหรือสร้างขึ้นภายใต้สัญญาฉบับนี้ให้ถือเป็น “งานอันมีลิขสิทธิ์” ภายใต้กฎหมายลิขสิทธิ์ของประเทศไทยและกฎหมายฉบับอื่นที่เกี่ยวข้อง

10. บทบัญญัติทั่วไป
10.1 หากบทบัญญัติใดในข้อกำหนดและเงื่อนไขการให้บริการนี้ ถือว่าผิดกฎหมาย เป็นโมฆะ หรือไม่สามารถบังคับใช้ได้ ไม่ว่าด้วยเหตุผลใดภายใต้กฎหมายของเขตอำนาจศาลใด ให้ถือว่าบทบัญญัตินั้นสามารถแยกออกจากกันได้จากข้อกำหนดและเงื่อนไขนี้ และไม่ส่งผลต่อความสมบูรณ์ และการมีผลบังคับใช้ของบทบัญญัติที่เหลือ หรือความสมบูรณ์และการมีผลบังคับใช้ของบทบัญญัติที่มีปัญหาภายใต้กฎหมายของเขตอำนาจศาลอื่นใด

10.2 ผู้ใช้บริการต้องไม่มอบหมาย ให้สิทธิการใช้งานต่อ หรือโอนสิทธิที่มอบให้แก่ผู้ใช้บริการในที่นี้ให้แก่ผู้อื่น หรือทำสัญญาช่วงข้อผูกพันใด ๆ ของผู้ใช้บริการ

บริษัท อินเทอร์เน็ต ประเทศไทย จำกัด (มหาชน)
Email: -
`;
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div>
      <Dialog
  open={open}
  onClose={handleClose}
  fullWidth
  PaperProps={{
    style: {
      width: '900px',
      maxWidth: '90vw', // ปรับให้ responsive
    },
  }}
>
  <DialogContent dividers>
    <DialogContentText
      id="scroll-dialog-description"
      tabIndex={-1}
      style={{ whiteSpace: "pre-line" }}
    >
       <Typography variant="h5" component="h2" fontWeight="bold" gutterBottom>
    ข้อกำหนดและเงื่อนไขการให้บริการ
  </Typography>
      {termsText}
    </DialogContentText>
  </DialogContent>
</Dialog>

    </div>
  );
}

export default PaymentService;
